import { useIonViewDidLeave, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import { showTab, hideTab } from "../components/Tabs";

import './Main.css'; 

interface ProfilePicProp extends RouteComponentProps<{
    img : string
    }> 
{} 

const ProfilePic : React.FC<ProfilePicProp> = ({match}) => {

    useIonViewDidLeave(() => {
        showTab();
    });

    useIonViewWillEnter(() => {
        hideTab();
    });

    return (
        <IonPage>
            <IonContent fullscreen>
                <IonToolbar className="toolbar-float">
                    <IonButtons slot="start">
                        <IonBackButton className="white-shadow" text="" defaultHref="/main" ></IonBackButton>
                    </IonButtons>
                </IonToolbar>
                <div className="profile-pic-wrapper">
                    <img className="profile-pic-big" src={ decodeURIComponent(match.params.img) } />
                </div>
            </IonContent>
        </IonPage>
    );
};

export default ProfilePic;